import {
  Action,
  ComplaintsType,
  Event,
  NavItem,
  News,
  ProjectsType,
  Slider,
  User,
} from "./types";

export const navMenu = [
  { id: "1", title: "Qui sommes-nous ?", url: "/qui-sommes-nous" },
  { id: "2", title: "Mon Eau", url: "/eau" },
  { id: "3", title: "Missions & Services", url: "/missions" },
  { id: "4", title: "Notre Patrimoine", url: "/patrimoine" },
];

export const users: User[] = [
  {
    id: 1,
    firstName: "Candice Schiner",
    lastName: "Schiner",
    email: "candice.schiner@gmail.com",
    company: "Dell",
    role: "Frontend Developer",
    verified: false,
    isDeleted: false,
  },
  {
    id: 2,
    firstName: "John Doe",
    lastName: "Schiner",
    email: "john.doe@gmail.com",
    company: "TechCorp",
    role: "Backend Developer",
    verified: true,
    isDeleted: false,
  },
  {
    id: 3,
    firstName: "Alice Johnson",
    lastName: "Schiner",
    email: "Alice.johnson@gmail.com",
    company: "WebTech",
    role: "UI Designer",
    verified: true,
    isDeleted: false,
  },
  {
    id: 4,
    firstName: "David Smith",
    lastName: "Schiner",
    email: "David.smith@gmail.com",
    company: "Innovate Inc.",
    role: "Fullstack Developer",
    verified: false,
    isDeleted: true,
  },
  {
    id: 5,
    firstName: "Emma Wilson",
    lastName: "Schiner",
    email: "Emma.wislon@gmail.com",
    company: "TechGuru",
    role: "Product Manager",
    verified: true,
    isDeleted: false,
  },
  {
    id: 6,
    firstName: "James Brown",
    lastName: "Schiner",
    email: "James.brown@gmail.com",
    company: "CodeGenius",
    role: "QA Engineer",
    verified: false,
    isDeleted: false,
  },
  {
    id: 7,
    firstName: "Laura White",
    lastName: "Schiner",
    email: "Laura.white@gmail.com",
    company: "SoftWorks",
    role: "UX Designer",
    verified: true,
    isDeleted: false,
  },
  {
    id: 8,
    firstName: "Michael Lee",
    lastName: "Schiner",
    email: "Michael.lee@gmail.com",
    company: "DevCraft",
    role: "DevOps Engineer",
    verified: false,
    isDeleted: false,
  },
  {
    id: 9,
    firstName: "Olivia Green",
    lastName: "Schiner",
    email: "Olivia.green@gmail.com",
    company: "WebSolutions",
    role: "Frontend Developer",
    verified: true,
    isDeleted: false,
  },
  {
    id: 10,
    firstName: "Robert Taylor",
    lastName: "Schiner",
    email: "Robert.taylor@gmail.com",
    company: "DataTech",
    role: "Data Analyst",
    verified: false,
    isDeleted: false,
  },
];

export const navItems: NavItem[] = [
  {
    title: "Dashboard",
    href: "/admin-dashboard",
    icon: "dashboard",
    label: "Dashboard",
  },
  {
    title: "Utilisateurs",
    href: "/admin-dashboard/utilisateurs",
    icon: "user",
    label: "user",
  },
  {
    title: "Messages",
    href: "/admin-dashboard/messages",
    icon: "mail",
    label: "user",
  },
  {
    title: "Actualités",
    href: "/admin-dashboard/actualités",
    icon: "news",
    label: "user",
  },

  {
    title: "Slider",
    href: "/admin-dashboard/sliders",
    icon: "images",
    label: "user",
  },
  {
    title: "Travaux",
    href: "/admin-dashboard/travaux",
    icon: "frame",
    label: "user",
  },

  {
    title: "Initiatives",
    href: "/admin-dashboard/initiative",
    icon: "share",
    label: "user",
  },

  {
    title: "Évènements",
    href: "/admin-dashboard/evenements",
    icon: "eventCalendar",
    label: "user",
  },
  {
    title: "Médiathèque",
    href: "/admin-dashboard/mediatheque/photos",
    icon: "images",
    label: "user",
    subMenu: [
      {
        title: "Photos",
        href: "/admin-dashboard/mediatheque/photos",
        icon: "media",
        label: "images",
      },
      {
        title: "Vidéos",
        href: "/admin-dashboard/mediatheque/videos",
        icon: "video",
        label: "videos",
      },
      {
        title: "Support de communications",
        href: "/admin-dashboard/mediatheque/support-de-communications",
        icon: "page",
        label: "videos",
      },
      {
        title: "Rapports d'activité",
        href: "/admin-dashboard/mediatheque/rapports-activites",
        icon: "page",
        label: "videos",
      },
      {
        title: "Actes administratifs",
        href: "/admin-dashboard/mediatheque/actes-administratifs",
        icon: "page",
        label: "videos",
      },
      {
        title: "Statuts",
        href: "/admin-dashboard/mediatheque/statuts",
        icon: "page",
        label: "videos",
      },
      {
        title: "Enquêtes publiques",
        href: "/admin-dashboard/mediatheque/enquetes-publiques",
        icon: "page",
        label: "videos",
      },
    ],
  },
  {
    title: "Presse",
    href: "/admin-dashboard/presse",
    icon: "notebook",
    label: "user",
  },
  {
    title: "Équipe",
    href: "/admin-dashboard/organigramme-equipe",
    icon: "text",
    label: "user",
  },
  {
    title: "Recrutement",
    href: "#",
    icon: "work",
    label: "user",
    subMenu: [
      {
        title: "Offres d'emploi",
        href: "/admin-dashboard/recrutement",
        icon: "work",
        label: "images",
      },
      {
        title: "Candidatures",
        href: "/admin-dashboard/candidatures-emploi",
        icon: "job",
        label: "videos",
      },
    ],
  },
  {
    title: "Budget",
    href: "/admin-dashboard/budgets",
    icon: "euro",
    label: "user",
  },
];

export const ModeratorNavItems: NavItem[] = [
  {
    title: "Dashboard",
    href: "/admin-dashboard",
    icon: "dashboard",
    label: "Dashboard",
  },
  {
    title: "Utilisateurs",
    href: "/admin-dashboard/utilisateurs",
    icon: "user",
    label: "user",
  },
  {
    title: "Messages",
    href: "/admin-dashboard/messages",
    icon: "mail",
    label: "user",
  },
  {
    title: "Actualités",
    href: "/admin-dashboard/actualités",
    icon: "news",
    label: "user",
  },

  {
    title: "Slider",
    href: "/admin-dashboard/sliders",
    icon: "images",
    label: "user",
  },
  {
    title: "Travaux",
    href: "/admin-dashboard/travaux",
    icon: "frame",
    label: "user",
  },

  {
    title: "Initiatives",
    href: "/admin-dashboard/initiative",
    icon: "share",
    label: "user",
  },

  {
    title: "Évènements",
    href: "/admin-dashboard/evenements",
    icon: "eventCalendar",
    label: "user",
  },
  {
    title: "Médiathèque",
    href: "/admin-dashboard/mediatheque/photos",
    icon: "images",
    label: "user",
    subMenu: [
      {
        title: "Photos",
        href: "/admin-dashboard/mediatheque/photos",
        icon: "media",
        label: "images",
      },
      {
        title: "Vidéos",
        href: "/admin-dashboard/mediatheque/videos",
        icon: "video",
        label: "videos",
      },
      {
        title: "Support de communications",
        href: "/admin-dashboard/mediatheque/support-de-communications",
        icon: "page",
        label: "videos",
      },
      {
        title: "Rapports d'activité",
        href: "/admin-dashboard/mediatheque/rapports-activites",
        icon: "page",
        label: "videos",
      },
      {
        title: "Actes administratifs",
        href: "/admin-dashboard/mediatheque/actes-administratifs",
        icon: "page",
        label: "videos",
      },
      {
        title: "Statuts",
        href: "/admin-dashboard/mediatheque/statuts",
        icon: "page",
        label: "videos",
      },
      {
        title: "Enquêtes publiques",
        href: "/admin-dashboard/mediatheque/enquetes-publiques",
        icon: "page",
        label: "videos",
      },
    ],
  },
  {
    title: "Presse",
    href: "/admin-dashboard/presse",
    icon: "notebook",
    label: "user",
  },
  {
    title: "Équipe",
    href: "/admin-dashboard/organigramme-equipe",
    icon: "text",
    label: "user",
  },
  {
    title: "Recrutement",
    href: "#",
    icon: "work",
    label: "user",
    subMenu: [
      {
        title: "Offres d'emploi",
        href: "/admin-dashboard/recrutement",
        icon: "work",
        label: "images",
      },
      {
        title: "Candidatures",
        href: "/admin-dashboard/candidatures-emploi",
        icon: "job",
        label: "videos",
      },
    ],
  },
  {
    title: "Budget",
    href: "/admin-dashboard/budgets",
    icon: "euro",
    label: "user",
  },
];

export const complaints: ComplaintsType[] = [
  {
    id: 1,
    lastName: "Candice ",
    firstName: "Schiner",
    company: "AQUAVESC",
    email: "Schiner@gmail.com",
    message:
      "lorem ipsum dolor sit amet, consectetur adip eu fugiat null lorem vitae lorem ",
    status: "En attente",
    createdAt: new Date("06/12/2015").toLocaleDateString("fr-FR"),
  },
  {
    id: 2,
    lastName: "John ",
    firstName: "Doe",
    company: "AQUAVESC & HYDREAULYS",
    email: "Doe@mail.com",
    message: "Salut .... ",
    status: "En cours",
    createdAt: new Date().toLocaleDateString("fr-FR"),
  },
  {
    id: 3,
    firstName: "John ",
    lastName: "Moris",
    company: "AQUAVESC & HYDREAULYS",
    email: "Moris@mail.com",
    message: "Bonjour ...",
    status: "Résolue",
    createdAt: new Date().toLocaleDateString("fr-FR"),
  },
];

export const sliders: Slider[] = [
  {
    id: 1,
    image: "https://picsum.photos/id/1/5000/3333",
  },
  {
    id: 2,
    image: "https://picsum.photos/id/2/5000/3333",
  },
  {
    id: 3,
    image: "https://picsum.photos/id/3/5000/3333",
  },
];

export const projects: ProjectsType[] = [
  {
    id: 1,
    title: "Projet 1",

    description:
      "lorem ipsum dolor sit amet, consectetur adip eu fugiat null lorem vitae lorem ",
    status: "Terminé",
    date_debut: new Date("06/12/2015").toLocaleDateString("fr-FR"),
    date_fin: new Date("06/12/2017").toLocaleDateString("fr-FR"),
  },
  {
    id: 2,
    title: "Projet 2",
    description: "Salut .... ",
    status: "En cours",
    date_debut: new Date("06/12/2015").toLocaleDateString("fr-FR"),
    date_fin: new Date("06/12/2017").toLocaleDateString("fr-FR"),
  },
  {
    id: 3,
    title: "Projet 3",
    description: "Bonjour ...",
    status: "En attente",
    date_debut: new Date("06/12/2015").toLocaleDateString("fr-FR"),
    date_fin: new Date("06/12/2017").toLocaleDateString("fr-FR"),
  },
];

export const news: News[] = [
  {
    id: 1,
    title: "Actualité 1",
    slug: "tilte",
    description:
      "lorem ipsum dolor sit amet, consectetur adip eu fugiat null lorem vitae lorem ",
    date: new Date("06/12/2015").toLocaleDateString("fr-FR"),
  },
  {
    id: 2,
    title: "Actualité 2",
    description: "Salut .... ",
    slug: "tilte",
    date: new Date().toLocaleDateString("fr-FR"),
  },
  {
    id: 3,
    title: "Actualité 3",
    description: "Bonjour ...",
    slug: "tilte",
    date: new Date().toLocaleDateString("fr-FR"),
  },
];

export const events: Event[] = [
  {
    id: 1,
    title: " Prochain bureau AQUAVESC",
    slug: "title-12",
    tag: "aqua",
    date: "03/14/2024",
    imgUrl: "https://picsum.photos/id/1/5000/3333",
    description:
      "il se tiendra le jeudi 14 mars 2024 à 8h au 12 rue Mansart à Versailles (78000).",
    createdAt: new Date("12/03/2024").toLocaleDateString("fr-FR"),
  },
  {
    id: 2,
    title: "Prochain Comité AQUAVESC",
    slug: "title-123",
    tag: "aqua",
    date: "03/27/2024",
    imgUrl: "https://picsum.photos/id/2/5000/3333",
    description:
      "il se tiendra le mercredi 27 mars 2024 à 18h au 12 rue Mansart à Versailles (78000)",
    createdAt: new Date("12/03/2024").toLocaleDateString("fr-FR"),
  },
];

export const actions: Action[] = [
  {
    id: 1,
    title: " Action 1",
    image: "https://picsum.photos/id/1/5000/3333",
    description: "lorem ipsum dolor sit amet, consectetur adip",
    date: new Date("06/12/2015").toLocaleDateString("fr-FR"),
  },
  {
    id: 2,
    title: "Action 2",
    image: "https://picsum.photos/id/2/5000/3333",
    description: "lorem ipsum dolor sit amet, consectetur adip",
    date: new Date("06/12/2013").toLocaleDateString("fr-FR"),
  },
  {
    id: 3,
    title: "Action 3",
    image: "https://picsum.photos/id/3/5000/3333",
    description: "lorem ipsum dolor sit amet, consectetur adip",
    date: new Date("06/12/2024").toLocaleDateString("fr-FR"),
  },
];
